import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  refererPayoutListingBegin,
  refererPayoutListingSuccess,
  refererPayoutListingErr,
  refererPayoutDetailBegin,
  refererPayoutDetailSuccess,
  refererPayoutDetailErr,
} = actions;

const refererPayoutListAPIName = '/admin/referer-payout-list';
const GetrefererPayoutDetailAPI = '/admin/';
const exportPayoutAPI = '/admin/referer-payout-export';
const fetchPartnerCoverageListing = '/admin/';

const payoutListing = (values) => {
  return async (dispatch) => {
    dispatch(refererPayoutListingBegin());
    try {
      const response = await DataService.post(refererPayoutListAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(refererPayoutListingErr(response?.data?.message));
      } else {
        dispatch(refererPayoutListingSuccess(response?.data));
        return response?.data?.result;
      }
    } catch (err) {
      dispatch(refererPayoutListingErr(err));
    }
  };
};
const getrefererpayoutDetail = (values) => {
  return async (dispatch) => {
    dispatch(refererPayoutDetailBegin());
    try {
      const response = await DataService.get(GetrefererPayoutDetailAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(refererPayoutDetailErr(response?.data?.message));
      } else {
        dispatch(refererPayoutDetailSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(refererPayoutDetailErr(err));
    }
  };
};
const exportPayout = (values) => {
  return async (dispatch) => {
    dispatch(refererPayoutListingBegin());
    try {
      const response = await DataService.export(exportPayoutAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(refererPayoutListingErr(response?.data?.message));
      } else {
        dispatch(refererPayoutListingSuccess(response?.data));
      }
      return response;
    } catch (err) {
      dispatch(refererPayoutListingErr(err));
    }
  };
};

export { payoutListing, getrefererpayoutDetail,exportPayout };
